__turbopack_context__.v({
  "backArrow": "IssuePageContent-module__9Rb9ia__backArrow",
  "backArrowIcon": "IssuePageContent-module__9Rb9ia__backArrowIcon",
  "bounce": "IssuePageContent-module__9Rb9ia__bounce",
  "bouncingArrow": "IssuePageContent-module__9Rb9ia__bouncingArrow",
  "container": "IssuePageContent-module__9Rb9ia__container",
  "divider": "IssuePageContent-module__9Rb9ia__divider",
  "dropdown": "IssuePageContent-module__9Rb9ia__dropdown",
  "infoSection": "IssuePageContent-module__9Rb9ia__infoSection",
  "issueInfoHelperText": "IssuePageContent-module__9Rb9ia__issueInfoHelperText",
  "modalContainer": "IssuePageContent-module__9Rb9ia__modalContainer",
  "officeCard": "IssuePageContent-module__9Rb9ia__officeCard",
  "scrollableContent": "IssuePageContent-module__9Rb9ia__scrollableContent",
  "sloganHelperText": "IssuePageContent-module__9Rb9ia__sloganHelperText",
  "stickyPanel": "IssuePageContent-module__9Rb9ia__stickyPanel",
  "swayScore": "IssuePageContent-module__9Rb9ia__swayScore",
});
